export default __webpack_public_path__ + "dd18b7ba8bcd6fb8901f2169b1cc5d5d.png";